/*
 * @Author: Teemo Ding
 * @Date: 2021-11-03 16:36:17
 * @LastEditTime: 2022-07-25 15:42:22
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/EditRecipientInfo/index.tsx
 */
import {
  Cascader,
  Checkbox,
  DatePicker,
  Input,
  ModalFooter,
  Select,
} from '@/src/components/Antd';
import { EditOutlined } from '@ant-design/icons';
import { useRequest } from 'ahooks';
import { Form } from 'antd';
import moment from 'moment';
import React, { memo, useState } from 'react';
import { MobileNumberAreaInfo } from 'src/pages/CustomerDatabaseConfig/Components/CustomerInfoModal';
// import SelectObjectAsValue from '@/src/components/SelectObjectAsValue';
import { get } from 'lodash';
//import { responseHandler } from 'src/tools/server';
//import { timeoutScroll } from 'src/tools/helper';
import {
  getLockerDeliveryMethods,
  getLockerPartners,
  getLockerPickup,
} from '@/src/request/order/createOrder';
import {
  EnumFieldType,
  SelectorType,
  Type,
} from 'src/components/FieldModal/config';
import {
  getDeliveryMethods,
  getLocation,
  getPartners,
  getPickups,
  getZones,
} from 'src/request/order';
import { calcDisableRange, hasValue } from 'src/tools/helper';
import { LogisticMethod } from 'src/types/common/logisticMethod';
import AddressFields from '../AddressFields';
//import { isNumber } from 'src/tools/helper';
import { FiledNameKeyMapping } from '@/src/pages/CustomerDatabaseConfig/config';
import { AddressFieldType } from '@/src/types/common/common';
import { useI18n } from 'src/hooks/useRouterChange';
import { dateOnlyFormat } from 'src/tools/constant';
import { onFinishFailed } from 'src/tools/helper';
import {
  getAreaCodeUuid,
  i18nGet,
  replaceI18nVariables,
  handleOnGetStoreDateFormat,
} from 'src/tools/tools';
import css from './css.module.less';

const baseFormat = dateOnlyFormat;
const formName = 'editRecipientInfo';
const symbol = '++~~**~~++';
// const Option = Select.Option;

const generateKey = (type, name) => {
  return `${type}${symbol}${name}`;
};

const getDetails = (key) => {
  const [type, name] = key.split(symbol);
  return { type, name };
};

const DeliveryMethod = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  // const i18n = useI18n();
  // const getI18n = (str) => {
  //   return i18nGet(i18n, str);
  // };
  const { value, onChange, deliveryMethodsOptions } = props;
  const deliveryMethodsIndex = deliveryMethodsOptions.filter(
    (o) => o.value == value,
  );
  const [edit, setEdit] = useState(false);

  const handleSelectChange = (value) => {
    setEdit(false);
    onChange(value);
  };

  return !(!deliveryMethodsIndex.length || edit) ? (
    <div>
      <div className={css.deliveryMethodsIndex}>
        {(deliveryMethodsIndex[0] || {}).label}{' '}
        <div className={css.editIcon} onClick={() => setEdit(true)}>
          <EditOutlined className={css.icon} /> {getI18n('general.edit')}
        </div>
      </div>
    </div>
  ) : (
    <Select
      size='large'
      value={value}
      onChange={handleSelectChange}
      options={deliveryMethodsOptions}
    />
  );
};

const EditRecipientInfo = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const storeDateFormat = handleOnGetStoreDateFormat();

  const {
    onCancel,
    orderUuid,
    addressBooks,
    fields: __field = [],
    customerInfoFields,
    destinations,
    // areaCodes = [],
    languageCode,
    defaultDeliveryInfo,
    getLockerZones,
    customer,
    buildData,
    salesChannelUuid,
    onConfirm,
    logisticsMethods,
    isSubscription,
  } = props;
  // const { data } = useRequest(getRecipient(orderUuid));
  const [form] = Form.useForm();
  const [disableDateList, setDisableDateList] = useState([]);
  const [selectableDateList, setSelectableDateList] = useState([]);
  const [partners, setPartners] = useState([]);
  const [formatFields, setFormatFields] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [pickupsOptions, setPickupsOptions] = useState([]);
  const fields = (__field || []).filter((i) => i.field);

  const { run: _getPartners } = useRequest(
    (data) =>
      customer
        ? getLockerPartners({ salesChannelUuid, lockerQuery: data })
        : getPartners(orderUuid, data, { isSubscription }),
    {
      manual: true,
      onSuccess: (res) => {
        setPartners(res);
      },
    },
  );

  const _getLockerPickup = () => {
    return customer
      ? getLockerPickup(salesChannelUuid)
      : getPickups(orderUuid, { isSubscription });
  };

  const { data: lockerZones = [] } = useRequest(() =>
    customer
      ? getLockerZones(buildData())
      : getZones(orderUuid, { isSubscription }),
  );

  const countryLocationsFormat = (children) => {
    const countryLocationsOptions = {} as any;
    countryLocationsOptions.label = get(children, 'location.name');
    countryLocationsOptions.uuid = get(children, 'location.uuid');
    countryLocationsOptions.code = get(children, 'location.code');
    if (get(children, 'subsets')) {
      countryLocationsOptions.children = ((children || {}).subsets || []).map(
        (item) => countryLocationsFormat(item),
      );
    } else {
      countryLocationsOptions.children = [];
    }
    return countryLocationsOptions;
  };

  const { run: _getLocation } = useRequest(
    (countryCode, locale) => getLocation(countryCode, locale),
    {
      manual: true,
      onSuccess: (res) => {
        setProvinces(countryLocationsFormat(res));
      },
    },
  );

  const { data: deliveryMethods = [], run: _getDeliveryMethods } = useRequest(
    (recipient) => {
      return customer
        ? getLockerDeliveryMethods({
            ...(buildData ? buildData() : {}),
            deliveryInfo: {
              recipient,
              logisticsMethod: LogisticMethod.Delivery,
            },
          })
        : getDeliveryMethods(orderUuid, recipient);
    },
    {
      manual: true,
      onSuccess: (res) => {
        const deliveryMethodUuid = form.getFieldValue('deliveryMethodUuid');
        const deliveryMethodIndex = res.filter(
          (o) => get(o, 'storeDeliveryMethod.uuid') == deliveryMethodUuid,
        );
        if (!deliveryMethodIndex.length) {
          form.setFieldsValue({ deliveryMethodUuid: '' });
        }
      },
    },
  );
  const logisticsMethod = (logisticsMethods || []).map((item) => ({
    label: item.title,
    value: item.logisticsMethod,
  }));
  const deliveryMethodsOptions = (deliveryMethods || []).map((item) => ({
    label: get(item, 'storeDeliveryMethod.name'),
    value: get(item, 'storeDeliveryMethod.uuid'),
  }));

  const zonesOption = (lockerZones || []).map((item) => ({
    label: item.regionName,
    value: item.regionName,
    children: (item.cities || []).map((city) => ({
      label: city.city,
      value: city.city,
      children: (city.counties || []).map((county) => ({
        label: county,
        value: county,
      })),
    })),
  }));

  const handleOnLockerPickups = async () => {
    const data = await _getLockerPickup();
    const _locations = data?.locations || [];
    if (defaultDeliveryInfo?.collectLocationUuid) {
      findDisableDate(_locations, defaultDeliveryInfo?.collectLocationUuid);
    }

    const options = _locations.map((item, index) => ({
      label: (
        <div key={index}>
          <div>{get(item, 'pickupLocation.locationName') || ''}</div>
          <span className='selectItemIntroduce'>
            {get(item, 'pickupLocation.addressLine', '')}
          </span>
        </div>
      ),
      value: get(item, 'pickupLocation.uuid', ''),
    }));
    setPickupsOptions(options);
  };

  const countriesAll = (destinations || []).reduce((pre, now) => {
    return pre.concat(now.country);
  }, []);
  const countryOption = (countriesAll || []).map((item) => ({
    label: item.name,
    value: get(item, 'code', ''),
  }));
  const addressBookOption = (addressBooks || []).map((item, index) => ({
    label: (
      <div key={index}>
        <div>
          {item.firstName || ''}
          {item.lastName || ''}
        </div>
        <span className={css.selectItemIntroduce}>
          {get(item, 'address', '')}
        </span>
      </div>
    ),
    value: get(item, 'uuid', ''),
  }));

  const preProcessFields = React.useMemo(() => {
    return (fields || []).map((i) => {
      const name = get(i, 'field.name') || [];
      const type = get(i, 'field.type');
      // const selectorType = get(i, 'field.selectorType');
      // const fieldType = get(i, 'field.name');
      const kName = generateKey(type, name);
      return { ...i, kName };
    });
  }, [fields]);

  const partnersOptions = React.useMemo(() => {
    let partnersOptionAll = [];
    partners.forEach((item) => {
      partnersOptionAll = partnersOptionAll.concat(item.lockers);
    });
    return (partnersOptionAll || []).map((item, index) => ({
      label: (
        <div key={index}>
          <div>{item.partnerCode || ''}</div>
          <span className={css.selectItemIntroduce}>
            {get(item, 'addressAlias', '')} | {get(item, 'address', '')}
          </span>
        </div>
      ),
      value: get(item, 'uuid', ''),
    }));
  }, [partners]);

  const mobileKey = React.useMemo(() => {
    const o =
      preProcessFields.find((i) => {
        const fieldType = get(i, 'field.name');
        return fieldType === EnumFieldType.MobileNumber;
      }) || {};
    const key = get(o, 'kName');
    return key;
  }, [preProcessFields]);

  const emailKey = React.useMemo(() => {
    const o =
      preProcessFields.find((i) => {
        const fieldType = get(i, 'field.name');
        return fieldType === EnumFieldType.Email;
      }) || {};
    const key = get(o, 'kName');
    return key;
  }, [preProcessFields]);

  const _formGenerator = (values) => {
    const _v = Object.keys(values).reduce((pre, now) => {
      const { name } = getDetails(now);
      let value = null;
      const currentV = values[now];
      if (name === EnumFieldType.MobileNumber) {
        const mobileNumber = get(currentV, 'mobileNumber');
        const areaCodeInfo = get(currentV, 'areaCodeInfo');
        return [
          ...pre,
          {
            field: { name },
            values: [getAreaCodeUuid(areaCodeInfo), mobileNumber],
          },
        ];
      } else {
        if (hasValue(currentV)) {
          value = [currentV];
        } else {
          value = [];
        }
      }
      return [
        ...pre,
        {
          field: { name },
          values: value,
        },
      ];
    }, []);
    return _v;
  };

  const mobileIsValid = (value) => {
    const { areaCodeInfo, mobileNumber } = value || {};
    const num = mobileNumber ? mobileNumber.toString() : null;
    const hasAreaCode = getAreaCodeUuid(areaCodeInfo);
    const hasValue = (num && !hasAreaCode) || (!num && hasAreaCode);
    return hasValue;
  };

  const disabledDate = (current) => {
    const [startDate, endDate] = selectableDateList.map((item) =>
      moment(item).format(baseFormat),
    );
    return (
      (disableDateList || []).includes(current.format(baseFormat)) ||
      current.isBefore(startDate) ||
      current.isAfter(moment(endDate).add(1, 'd'))
    );
  };
  /**Country变化时调用 */
  const changeCountry = (countryCode) => {
    const destinationsIndex = (destinations || []).filter(
      (o) => o.country.code === countryCode,
    );
    if (countryCode && languageCode) {
      _getLocation(countryCode, languageCode);
    }
    if (destinationsIndex.length) {
      setFormatFields(destinationsIndex[0].format.fields);
      form.setFieldsValue({ [AddressFieldType.Subdivision]: [] });
    }
  };
  const defaultCountry = React.useMemo(() => {
    return {
      logisticsMethod: get(defaultDeliveryInfo, 'logisticsMethod'),
      country: get(defaultDeliveryInfo, 'recipient.countryVO.code'),
      [AddressFieldType.AddressLine1]: get(
        defaultDeliveryInfo,
        'recipient.address',
      ),
      [AddressFieldType.AddressLine2]: get(
        defaultDeliveryInfo,
        'recipient.address2',
      ),
      [AddressFieldType.City]: get(defaultDeliveryInfo, 'recipient.city'),
      [AddressFieldType.Subdivision]: [
        ...(get(defaultDeliveryInfo, 'recipient.countryVO.uuid')
          ? [defaultDeliveryInfo.recipient.countryVO]
          : []),
        ...(get(defaultDeliveryInfo, 'recipient.provinceVO.uuid')
          ? [defaultDeliveryInfo.recipient.provinceVO]
          : []),
        ...(get(defaultDeliveryInfo, 'recipient.cityVO.uuid')
          ? [defaultDeliveryInfo.recipient.cityVO]
          : []),
        ...(get(defaultDeliveryInfo, 'recipient.countyVO.uuid')
          ? [defaultDeliveryInfo.recipient.countyVO]
          : []),
      ],
      [AddressFieldType.Postcode]: get(
        defaultDeliveryInfo,
        'recipient.postalCode',
      ),
    };
  }, [defaultDeliveryInfo]);

  // 这里与下面的useEffect 里的 _getLocation 重复,会导致发送请求失败
  // React.useMemo(() => {
  //   changeCountry(get(defaultDeliveryInfo, 'recipient.countryVO.code'));
  // }, [get(defaultDeliveryInfo, 'recipient.countryVO.code')]);

  React.useEffect(() => {
    //初始化数据
    const iniValue = preProcessFields.reduce((pre, now) => {
      let value = null;
      const name = get(now, 'field.name') || [];
      const _v = get(now, 'values') || [];
      const type = get(now, 'field.type');
      const selectorType = get(now, 'field.selectorType');
      if (name === EnumFieldType.MobileNumber) {
        const [areaCodeUuid, mobileNumber] = _v;
        value = { areaCodeInfo: { uuid: areaCodeUuid }, mobileNumber };
      } else {
        if (type !== Type.Selector) {
          if (name === EnumFieldType.DateOfBirth) {
            const d = _v[0];
            const m = _v[1];
            const y = _v[2];
            value = { y, m, d };
          } else {
            value = _v[0];
          }
        }
        if (type === Type.Selector) {
          if (selectorType === SelectorType.Multiple) {
            value = _v;
          } else {
            value = _v[0];
          }
        }
      }
      const k = generateKey(type, name);
      return { ...pre, [k]: value };
    }, {});

    const recipient = get(defaultDeliveryInfo, 'recipient', {});
    if (
      recipient &&
      get(defaultDeliveryInfo, 'logisticsMethod') === LogisticMethod.Delivery
    ) {
      _getDeliveryMethods(recipient);
      changeCountry(recipient.countryVO.code);
      // _getLocation(recipient.countryVO.code, recipient.locale);
    }

    if (
      get(defaultDeliveryInfo, 'lockerVO.province') &&
      get(defaultDeliveryInfo, 'logisticsMethod') ===
        LogisticMethod.ParcelLocker
    ) {
      _getPartners({
        region: get(defaultDeliveryInfo, 'lockerVO.province'),
        city: get(defaultDeliveryInfo, 'lockerVO.city'),
        county: get(defaultDeliveryInfo, 'lockerVO.county'),
      });
    }
    if (
      get(defaultDeliveryInfo, 'collectLocationUuid') &&
      get(defaultDeliveryInfo, 'logisticsMethod') ===
        LogisticMethod.ClickCollect
    ) {
      handleOnLockerPickups();
    }
    form.setFieldsValue({
      fields: iniValue,
      ...defaultCountry,
      deliveryMethodUuid: get(defaultDeliveryInfo, 'deliveryMethodUuid'),
      district: [
        get(defaultDeliveryInfo, 'lockerVO.province'),
        get(defaultDeliveryInfo, 'lockerVO.city'),
        get(defaultDeliveryInfo, 'lockerVO.county'),
      ],
      parcelLockerAddress: get(defaultDeliveryInfo, 'lockerVO.uuid'),
      pickupLocation: get(defaultDeliveryInfo, 'collectLocationUuid'),
      pickupDate: get(defaultDeliveryInfo, 'collectionDate')
        ? moment(defaultDeliveryInfo.collectionDate)
        : '',
    });
  }, []);

  const onFinish = (values) => {
    const recipientFields = _formGenerator(values.fields);
    let deliveryInfo = {};
    if (values.logisticsMethod == LogisticMethod.ClickCollect) {
      deliveryInfo = {
        logisticsMethod: values.logisticsMethod,
        deliveryMethodUuid: values.deliveryMethodUuid,
        collectLocationUuid: values.pickupLocation,
        collectionDate: moment(values.pickupDate).format(baseFormat),
      };
    } else if (values.logisticsMethod == LogisticMethod.ParcelLocker) {
      deliveryInfo = {
        logisticsMethod: values.logisticsMethod,
        lockerUuid: values.parcelLockerAddress,
        deliveryMethodUuid: values.deliveryMethodUuid,
        // recipient: { uuid: values.parcelLockerAddress },
      };
    } else {
      const { AddressLine1, AddressLine2, City, Subdivision, Postcode } =
        values;
      deliveryInfo = {
        logisticsMethod: values.logisticsMethod,
        deliveryMethodUuid: values.deliveryMethodUuid,
        recipient: {
          countryVO: {
            uuid: get(Subdivision, [0, 'uuid']),
            name: get(Subdivision, [0, 'label']),
            code: get(Subdivision, [0, 'code']),
          },
          address: AddressLine1,
          address2: AddressLine2,
          city: City,
          cityVO: {
            uuid: get(Subdivision, [2, 'uuid']),
            name: get(Subdivision, [2, 'label']),
            code: get(Subdivision, [2, 'code']),
          },
          provinceVO: {
            uuid: get(Subdivision, [1, 'uuid']),
            name: get(Subdivision, [1, 'label']),
            code: get(Subdivision, [1, 'code']),
          },
          countyVO: {
            uuid: get(Subdivision, [3, 'uuid']),
            name: get(Subdivision, [3, 'label']),
            code: get(Subdivision, [0, 'code']),
          },
          postalCode: Postcode,
        },
      };
    }
    const formData = { recipientFields, deliveryInfo };
    if (onConfirm) {
      onConfirm(formData);
    }
  };

  const findDisableDate = (_lockerPickups, pickupLocationUuid) => {
    const location = (_lockerPickups || []).find(
      (o) => o.pickupLocation.uuid == pickupLocationUuid,
    );
    const pickupAvailableTime = get(
      location,
      'pickupLocation.pickupAvailableTime',
    );
    const { selectableDates, blockOutDates, customizes } =
      pickupAvailableTime || {};
    const disableRanges = calcDisableRange({
      selectableDates,
      blockOutDates,
      customizes,
      format: baseFormat,
    });
    setDisableDateList(disableRanges);
    setSelectableDateList(selectableDates);
  };
  const onValuesChange = (changedValues, allValues) => {
    if (Object.keys(changedValues).includes('district')) {
      form.setFieldsValue({
        parcelLockerAddress: null,
      });
      _getPartners({
        region: changedValues['district'][0],
        city: changedValues['district'][1],
        county: changedValues['district'][2],
      });
    } else if (changedValues.logisticsMethod === LogisticMethod.ClickCollect) {
      handleOnLockerPickups();
    } else if (Object.keys(changedValues).includes('sameAsBuyerInfo')) {
      preProcessFields.forEach((item) => {
        const customerInfoFieldsIndex = (customerInfoFields || []).filter((o) =>
          get(item, 'field.name') === EnumFieldType.MobileNumber
            ? get(o, 'field.fieldType') == EnumFieldType.AreaCodeMobileNumber
            : get(o, 'field.fieldType') == get(item, 'field.name'),
        );
        if (item.field.name == EnumFieldType.MobileNumber) {
          form.setFieldsValue({
            fields: {
              [item.kName]: {
                areaCodeInfo: {
                  uuid: get(customerInfoFieldsIndex[0], 'value[0]'),
                },
                mobileNumber: get(customerInfoFieldsIndex[0], 'value[1]'),
              },
            },
          });
        } else {
          form.setFieldsValue({
            fields: {
              [item.kName]: get(customerInfoFieldsIndex[0], 'value[0]'),
            },
          });
        }
      });
    } else if (Object.keys(changedValues).includes('fields')) {
      form.setFieldsValue({
        sameAsBuyerInfo: false,
      });
    } else if (Object.keys(changedValues).includes('addressBook')) {
      const addressBook = (addressBooks || []).find(
        (o) => o.uuid === changedValues['addressBook'],
      );
      if (addressBook.countryVO.code && addressBook.locale) {
        _getLocation(addressBook.countryVO.code, addressBook.locale);
      }
      _getDeliveryMethods(addressBook);
      form.setFieldsValue({
        country: addressBook.countryVO.code,
        [AddressFieldType.AddressLine1]: addressBook.address,
        [AddressFieldType.AddressLine2]: addressBook.address2,
        [AddressFieldType.City]: addressBook.city,
        [AddressFieldType.Subdivision]: [
          addressBook.countryVO,
          addressBook.provinceVO,
          ...(get(addressBook, 'cityVO.uuid') ? [addressBook.cityVO] : []),
          ...(get(addressBook, 'countyVO.uuid') ? addressBook.countyVO : []),
        ],
        [AddressFieldType.Postcode]: addressBook.postalCode,
      });
      const destinationsIndex = (destinations || []).filter(
        (o) => o.country.code === addressBook.countryVO.code,
      );
      setFormatFields(destinationsIndex[0].format.fields);
    } else if (Object.keys(changedValues).includes('country')) {
      // setFormatFields(destinationsIndex[0].format.fields);
      changeCountry(changedValues['country']);
    } else if (
      Object.keys(changedValues).includes(AddressFieldType.Subdivision)
    ) {
      const recipient = {
        countryVO: changedValues[AddressFieldType.Subdivision][0],
        provinceVO: changedValues[AddressFieldType.Subdivision][1],
        cityVO: changedValues[AddressFieldType.Subdivision][2],
      };
      _getDeliveryMethods(recipient);
    }
  };

  return (
    <div>
      <Form
        name={formName}
        form={form}
        className={css.editBuyerInfo}
        onFinishFailed={(error) => {
          onFinishFailed(formName, error);
        }}
        onValuesChange={onValuesChange}
        onFinish={onFinish}>
        <h3>
          {' '}
          {getI18n('allOrders.createneworder.component_customer_RecipientInfo')}
        </h3>
        {!isSubscription && (
          <Form.Item
            name='sameAsBuyerInfo'
            valuePropName='checked'
            labelCol={{ span: 24 }}>
            <Checkbox>
              {getI18n('allOrders.createneworder.sameasbuyerinfo')}
            </Checkbox>
          </Form.Item>
        )}
        <div className={css.preProcessFields}>
          {(preProcessFields || []).map((i, index) => {
            const name = get(i, 'field.name') || [];
            const i18nKey = FiledNameKeyMapping[name];
            const title = getI18n(i18nKey);
            const regex = ((get(i, 'field.regex') || '').match(
              /(?:\/).*?(?=\/)/,
            ) || [])[0];

            const required = get(i, 'field.required');
            const fieldType = get(i, 'field.name');
            const k = get(i, 'kName') || [];

            const child = () => {
              if (fieldType === EnumFieldType.MobileNumber) {
                return (
                  <Form.Item
                    key={index}
                    noStyle
                    shouldUpdate={(p, c) => {
                      const epV = get(p, emailKey);
                      const ecV = get(c, emailKey);
                      const mpV = get(p, mobileKey);
                      const mcV = get(c, mobileKey);
                      return epV !== ecV || mpV !== mcV;
                    }}>
                    {({ getFieldValue }) => {
                      setTimeout(() => {
                        form.validateFields([emailKey]);
                      });
                      return (
                        <Form.Item
                          name={['fields', k]}
                          label={`${title} ${required ? '*' : ''}`}
                          labelCol={{ span: 24 }}
                          rules={[
                            {
                              required: required,
                              message: replaceI18nVariables(
                                getI18n('general.fieldisrequired'),
                                title,
                              ),
                            },
                            {
                              validator: async (x, value) => {
                                const isMobileNumberValid =
                                  mobileIsValid(value);
                                if (isMobileNumberValid) {
                                  return Promise.reject(
                                    new Error(
                                      getI18n(
                                        'allOrders.createneworder.component_customer_editrecipientinfo_error',
                                      ),
                                    ),
                                  );
                                }
                              },
                            },
                          ]}>
                          <MobileNumberAreaInfo />
                        </Form.Item>
                      );
                    }}
                  </Form.Item>
                );
              } else if (fieldType === EnumFieldType.Email) {
                return (
                  <Form.Item
                    noStyle
                    shouldUpdate={(p, c) => {
                      const epV = get(p, emailKey);
                      const ecV = get(c, emailKey);
                      const mpV = get(p, mobileKey);
                      const mcV = get(c, mobileKey);
                      return epV !== ecV || mpV !== mcV;
                    }}>
                    {({ getFieldValue }) => {
                      setTimeout(() => {
                        form.validateFields([mobileKey]);
                      });
                      return (
                        <Input
                          formProps={{
                            name: ['fields', k],
                            label: `${title} ${required ? '*' : ''}`,
                            labelCol: { span: 24 },
                            rules: [
                              {
                                required: required,
                                message: replaceI18nVariables(
                                  getI18n('general.fieldisrequired'),
                                  title,
                                ),
                              },
                              {
                                type: 'email',
                                message: getI18n(
                                  'allOrders.createneworder.component_customer_editrecipientinfo_inputvalidemail',
                                ),
                              },
                            ],
                          }}
                          size='large'
                          maxLength={200}
                        />
                      );
                    }}
                  </Form.Item>
                );
              } else {
                return (
                  <Input
                    formProps={{
                      name: ['fields', k],
                      rules: [
                        {
                          required: required,
                          message: replaceI18nVariables(
                            getI18n('general.fieldisrequired'),
                            title,
                          ),
                        },
                        {
                          pattern: regex ? new RegExp(regex) : '',
                          message: getI18n('general.invalidformat'),
                        },
                      ],
                      label: `${title} ${required ? '*' : ''}`,
                      labelCol: { span: 24 },
                    }}
                    size='large'
                    maxLength={200}
                  />
                );
              }
            };
            return <React.Fragment key={fieldType}>{child()}</React.Fragment>;
          })}
        </div>
        <Form.Item
          label={`${getI18n('general.logisticMethod')}*`}
          name='logisticsMethod'
          className={css.logisticsMethod}
          labelCol={{ span: 24 }}
          rules={[
            {
              required: true,
              message: replaceI18nVariables(
                getI18n('general.fieldisrequired'),
                getI18n('general.logisticMethod'),
              ),
            },
          ]}>
          <Select
            size='large'
            options={logisticsMethod}
            disabled={isSubscription}
          />
        </Form.Item>
        <Form.Item
          shouldUpdate={(p, c) => {
            const epV = get(p, 'logisticsMethod');
            const ecV = get(c, 'logisticsMethod');
            const epP = get(p, [AddressFieldType.Subdivision]);
            const ecP = get(c, [AddressFieldType.Subdivision]);
            return epV !== ecV || epP !== ecP;
          }}>
          {({ getFieldValue }) => {
            if (getFieldValue('logisticsMethod') == LogisticMethod.Delivery) {
              return (
                <div>
                  <h3>
                    {getI18n(
                      `allOrders.orderDetail.component_customer_shippingadd`,
                    )}
                  </h3>
                  <Form.Item
                    name='addressBook'
                    label={getI18n('allOrders.orderDetail.addressBook')}
                    className={css.addressBook}
                    labelCol={{ span: 24 }}>
                    <Select options={addressBookOption} size='large' />
                  </Form.Item>
                  <Form.Item
                    name='country'
                    label={`${getI18n('general.countryRegion')}*`}
                    rules={[
                      {
                        required: true,
                        message: getI18n(
                          'allOrders.createneworder.component_customer_BillingAddress_countrymsg',
                        ),
                      },
                    ]}
                    labelCol={{ span: 24 }}>
                    <Select size='large' options={countryOption} />
                  </Form.Item>
                  <AddressFields
                    provinces={[provinces]}
                    fields={formatFields}
                  />
                  {getFieldValue([AddressFieldType.Subdivision]) && (
                    <Form.Item
                      label={`${getI18n('general.deliveryMethod')}*`}
                      name='deliveryMethodUuid'
                      className={css.logisticsMethod}
                      rules={[
                        {
                          required: true,
                          message: replaceI18nVariables(
                            getI18n('general.fieldisrequired'),
                            getI18n('general.deliveryMethod'),
                          ),
                        },
                      ]}
                      labelCol={{ span: 24 }}>
                      <DeliveryMethod
                        deliveryMethodsOptions={deliveryMethodsOptions}
                      />
                      {/* <Select size='large' options={deliveryMethodsOptions} /> */}
                    </Form.Item>
                  )}
                </div>
              );
            } else if (
              getFieldValue('logisticsMethod') == LogisticMethod.ParcelLocker
            ) {
              return (
                <div>
                  <h3>{getI18n('allOrders.createneworder.parcelLocker')}</h3>
                  <Form.Item
                    name='district'
                    rules={[
                      {
                        required: true,
                        message: `District Is Required`,
                      },
                    ]}
                    label={`${getI18n('allOrders.createneworder.district')}*`}
                    labelCol={{ span: 24 }}>
                    <Cascader options={zonesOption} size='large' />
                  </Form.Item>
                  <Form.Item
                    name='parcelLockerAddress'
                    rules={[
                      {
                        required: true,
                        message: replaceI18nVariables(
                          getI18n('general.fieldisrequired'),
                          getI18n(
                            'allOrders.createneworder.parcelLockerAddress',
                          ),
                        ),
                      },
                    ]}
                    label={`${getI18n(
                      'allOrders.createneworder.parcelLockerAddress',
                    )}*`}
                    labelCol={{ span: 24 }}>
                    <Select size='large' options={partnersOptions} />
                  </Form.Item>
                </div>
              );
            } else if (
              getFieldValue('logisticsMethod') == LogisticMethod.ClickCollect
            ) {
              return (
                <div>
                  <h3>
                    {getI18n(
                      'allOrders.createneworder.clickandCollectPickupInformation',
                    )}
                  </h3>
                  <Form.Item
                    name='pickupLocation'
                    rules={[
                      {
                        required: true,
                        message: replaceI18nVariables(
                          getI18n('general.fieldisrequired'),
                          getI18n(
                            'allOrders.createneworder.clickandCollectPickupLocation',
                          ),
                        ),
                      },
                    ]}
                    label={`${getI18n(
                      'allOrders.createneworder.clickandCollectPickupLocation',
                    )}*`}
                    labelCol={{ span: 24 }}>
                    <Select options={pickupsOptions} size='large' />
                  </Form.Item>
                  <Form.Item
                    name='pickupDate'
                    rules={[
                      {
                        required: true,
                        message: replaceI18nVariables(
                          getI18n('general.fieldisrequired'),
                          getI18n('allOrders.createneworder.pickupTime'),
                        ),
                      },
                    ]}
                    label={`${getI18n('allOrders.createneworder.pickupTime')}*`}
                    labelCol={{ span: 24 }}>
                    <DatePicker
                      size='large'
                      disabledDate={disabledDate}
                      storeDateFormat={storeDateFormat}
                    />
                  </Form.Item>
                </div>
              );
            }
          }}
        </Form.Item>
      </Form>
      <ModalFooter
        onOk={() => form.submit()}
        onCancel={() => onCancel()}
        okText={getI18n('general.confirm')}
      />
    </div>
  );
};

export default memo(EditRecipientInfo);
